import React, { useEffect, useState } from "react";
import {
  Stack,
  TableRow,
  TableHead,
  TableContainer,
  TableBody,
  Table,
  styled,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import axios from "axios";
import { BaseUrl } from "../../Container/BaseUrl/BaseUrl";
import moment from "moment";
import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";

// Styled table cells
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#e9e9e9",
    color: theme.palette.common.black,
    padding: "10px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "13px",
  },
}));

const StyledTableCell2 = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#fff",
  color: theme.palette.common.black,
  padding: "7px 10px",
  fontSize: "13px",
}));

const DncrLogHistory = ({ selectedUser }) => {
  const [dncrList, setDncrList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchDncrLogs = async () => {
    if (!selectedUser?.id) return;

    try {
      setLoading(true);
      const response = await axios.post(
        `${BaseUrl}/users/dncrlog`,
        { unique_id: selectedUser.id },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      );

      if (response.data?.status) {
        setDncrList(response.data.data || []);
      } else {
        setDncrList([]);
      }
    } catch (error) {
      console.error("Failed to fetch DNCR logs:", error);
      setDncrList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDncrLogs();
  }, [selectedUser]);

  return (
    <div
      className="tab-pane fade show active"
      id="pills-profile"
      role="tabpanel"
      aria-labelledby="pills-profile-tab"
    >
      <TableContainer sx={{ height: "100%", width: "100%", fontSize: "13px" }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Agent</StyledTableCell>
              <StyledTableCell>Date</StyledTableCell>
              <StyledTableCell>DNCR Status</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dncrList.length > 0 ? (
              dncrList.map((item, index) => (
                <TableRow key={item._id || index} hover>
                  <StyledTableCell2 style={{ width: "max-content" }}>
                    {item?.agent_id?.username || "N/A"}
                  </StyledTableCell2>
                  <StyledTableCell2>
                    {moment(item.created_at).format("L LT")}
                  </StyledTableCell2>
                  <StyledTableCell2>
                    {item.DNCR_FLAG ? (
                      <AiFillCheckCircle color="green" size={17} />
                    ) : (
                      <AiFillCloseCircle color="red" size={17} />
                    )}
                  </StyledTableCell2>
                </TableRow>
              ))
            ) : !loading ? (
              <TableRow>
                <StyledTableCell2 colSpan={3} align="center">
                  No DNCR logs found.
                </StyledTableCell2>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default DncrLogHistory;
